import StatusChip from "@entrilia/shared/components/StatusChip";

interface Props {
  isActive: boolean;
}

const AgentInboxChannelStatusChip = ({ isActive }: Props) => {
  if (isActive) {
    return <StatusChip label="Active" color={(t) => t.palette.success.main} />;
  }

  return <StatusChip label="Inactive" color={(t) => t.palette.text.secondary} />;
};

export default AgentInboxChannelStatusChip;
